// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"3e4add21","925":"22cc1b8f"}[chunkId] + ".chunk.js";
};